import { usePlatformLocale } from "../lib/platform-language";
import { type Locale } from "../lib/i18n";

export function LanguageSwitcher({
  locale,
  onChange,
  compact = false,
}: {
  locale: Locale;
  onChange: (locale: Locale) => void;
  compact?: boolean;
}) {
  usePlatformLocale();
  return (
    <div className={`language-switcher${compact ? " compact" : ""}`} aria-label={locale === "sq" ? "Gjuha" : "Language"}>
      {(["sq", "en"] as const).map((item) => (
        <button
          key={item}
          type="button"
          className={locale === item ? "active" : ""}
          onClick={() => onChange(item)}
          aria-pressed={locale === item}
        >
          {item.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
